export const variantsViewport = {
  viewportWidth: {
    small: '(max-width: 600px)',
    medium: '(min-width: 601px) and (max-width: 1024px)',
    large: '(min-width: 1025px) and (max-width: 1450px)',
    xlarge: '(min-width: 1451px)',
  },
};
